export interface CustomEndpoint {
  values: any;
}
